export const RENDER_BLOCK_COMPONENTS = {
  method_list: 'BotMethodList',
  delivery_zone: 'BotDeliveryZone',
  slot_windows: 'BotSlotSchedule',
  slot_schedule: 'BotSlotSchedule',
  menu_items: 'BotMenuList',
  order_summary: 'BotOrderSummary',
  product_list: 'BotProductList',
  product_detail: 'BotProductDetail',
  category_list: 'BotCategoryList',
  inventory_report: 'BotInventoryReport',
  discount_code_list: 'BotDiscountCodeList',
  pricing_tier_list: 'BotPricingTierList',
  fulfillment_method_list: 'BotFulfillmentMethodList',
  tax_setup: 'BotTaxSetup',
  store_profile: 'BotStoreProfile',
  ecommerce_order_summary: 'BotEcommerceOrderSummary',
  error: 'BotError',
  order_total_breakdown: 'BotOrderTotalBreakdown',
  fee_config: 'BotFeeConfig',
  smartlist_list: 'BotSmartlistList',
  smartlist_detail: 'BotSmartlistList',
  smartlist_diagnosis: 'BotSmartlistDiagnosis',
  slot_products: 'BotSlotProducts',
  shortfall_logged: 'BotShortfallLogged',
  sms_opt_out_summary: 'BotSmsOptOutSummary',
  customer_segments: 'BotCustomerSegments',
  geocoding_coverage: 'BotGeocodingCoverage',
  line_item_breakdown: 'BotLineItemBreakdown',
  order_address: 'BotOrderAddress',
  customer_contact: 'BotCustomerContact'
}

export function renderBlockComponent(type) {
  return RENDER_BLOCK_COMPONENTS[type] || null
}

export function normalizeRenderBlock(value) {
  if (Array.isArray(value)) return value.map(normalizeRenderBlock)
  if (value && typeof value === 'object') {
    const out = {}
    for (const [k, v] of Object.entries(value)) {
      if (typeof v === 'function') continue
      out[k] = normalizeRenderBlock(v)
    }
    return out
  }
  return value
}
